import { render, staticRenderFns } from "./PolarGraph.vue?vue&type=template&id=54b5fe84&scoped=true&"
import script from "./PolarGraph.vue?vue&type=script&lang=js&"
export * from "./PolarGraph.vue?vue&type=script&lang=js&"
import style0 from "./PolarGraph.vue?vue&type=style&index=0&id=54b5fe84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b5fe84",
  null
  
)

export default component.exports